const map = {
	"./App.css": 4050,
	"./components/AddClub/AddClub.css": 3491,
	"./components/AddTutor/AddTutor.css": 3907,
	"./components/BoxToBox/BoxToBox.css": 8627,
	"./components/BrandTheme/BrandTheme.css": 8777,
	"./components/Button/Button.css": 5713,
	"./components/CVSectionSettings/CVSectionSettings.css": 5299,
	"./components/CardDropdown/CardDropdwon.css": 483,
	"./components/ControlButton/ControlButton.css": 8123,
	"./components/CourseCard/CourseCard.css": 9399,
	"./components/CourseCard/CourseCardInfo.css": 9099,
	"./components/CourseCard/UnitCard.css": 4406,
	"./components/CourseInfo/CourseInfo.css": 6667,
	"./components/Courses/Courses.css": 7399,
	"./components/CreateCourse/CreateCourse.css": 2115,
	"./components/CreateWorkExperience/CreateWorkExperience.css": 6811,
	"./components/CropImage/CropImage.css": 9763,
	"./components/CustomLogin/CustomLogin.css": 183,
	"./components/Dropdown/Dropdown.css": 243,
	"./components/ExistingCourses/ExistingCourses.css": 9035,
	"./components/GradingCategory/GradingCategory.css": 8695,
	"./components/Header/Header.css": 2627,
	"./components/Heading/Heading.css": 4843,
	"./components/Input/Input.css": 9275,
	"./components/InstitutionType/InstitutionType.css": 8943,
	"./components/Label/Label.css": 6055,
	"./components/LoadingButton/LoadingButton.css": 8875,
	"./components/MainControlButton/MainControlButton.css": 7891,
	"./components/MessageCentre/MessageCentre.css": 4311,
	"./components/MetricCatalogueModal/MetricCatalogueModal.css": 3425,
	"./components/Mfa/Mfa.css": 3187,
	"./components/MultiplePlayers/Multiplayers.css": 8938,
	"./components/MyCourses/MyCourses.css": 1159,
	"./components/NavSidebar/NavSidebar.css": 8227,
	"./components/Navbar/Navbar.css": 941,
	"./components/NewCategory/NewCategory.css": 787,
	"./components/Password/Password.css": 1635,
	"./components/Player/Player.css": 9043,
	"./components/PlayerCVSectionSettings/PlayerCVSectionSettings.css": 2755,
	"./components/PlayerCentre/PlayerCentre.css": 3993,
	"./components/PlayerInfo/PlayerInfo.css": 7523,
	"./components/PlayersCard/PlayersCard.css": 6351,
	"./components/Profile/Profile.css": 2279,
	"./components/ProfileFieldType/ProfileFieldType.css": 4479,
	"./components/QualificationGrading/QualificationGrading.css": 767,
	"./components/RegisterPlayer/RegisterPlayer.css": 7573,
	"./components/Search/Search.css": 3321,
	"./components/SessionTimeoutWarning/SessionTimeoutWarning.css": 4975,
	"./components/Sidebar/Sidebar.css": 3783,
	"./components/Textarea/Textarea.css": 4853,
	"./components/TransferableSkills/TransferableSkills.css": 6211,
	"./components/UnitInfo/UnitInfo.css": 4705,
	"./components/UserProfileCard/CreateProfileField.css": 5812,
	"./components/WorkExperience/WorkExperience.css": 723,
	"./index.css": 9555,
	"./pages/AllCourses/AllCourses.css": 7199,
	"./pages/CVSectionSettings/CVSectionSettingsPage.css": 2314,
	"./pages/ContentReview/ContentReview.css": 7883,
	"./pages/Dashboard/AdminDashboard.css": 8320,
	"./pages/IndividualAccounts/IndividualAccounts.css": 6079,
	"./pages/MetricCatalogue/MetricCatalogue.css": 4011,
	"./pages/OrganizationUserProfile/OrganizationUserProfile.css": 5903,
	"./pages/PlayerCategories/PlayerCategories.css": 1655,
	"./pages/SkillCatalogue/SkillCatalogue.css": 4889,
	"./pages/Support/Support.css": 8119,
	"./pages/Template4Stats/Template4Stats.css": 8423,
	"./pages/Theme/theme.css": 3623,
	"./pages/UserProfile/UserProfile.css": 1403,
	"./pages/WorkExperienceSummary/WorkExperienceSummary.css": 1127,
	"./styles/legacy-buttons.css": 9219,
	"./styles/shell.css": 3074,
	"./styles/tokens.css": 5392,
	"./styles/ui.css": 5336,
	"App.css": 4050,
	"components/AddClub/AddClub.css": 3491,
	"components/AddTutor/AddTutor.css": 3907,
	"components/BoxToBox/BoxToBox.css": 8627,
	"components/BrandTheme/BrandTheme.css": 8777,
	"components/Button/Button.css": 5713,
	"components/CVSectionSettings/CVSectionSettings.css": 5299,
	"components/CardDropdown/CardDropdwon.css": 483,
	"components/ControlButton/ControlButton.css": 8123,
	"components/CourseCard/CourseCard.css": 9399,
	"components/CourseCard/CourseCardInfo.css": 9099,
	"components/CourseCard/UnitCard.css": 4406,
	"components/CourseInfo/CourseInfo.css": 6667,
	"components/Courses/Courses.css": 7399,
	"components/CreateCourse/CreateCourse.css": 2115,
	"components/CreateWorkExperience/CreateWorkExperience.css": 6811,
	"components/CropImage/CropImage.css": 9763,
	"components/CustomLogin/CustomLogin.css": 183,
	"components/Dropdown/Dropdown.css": 243,
	"components/ExistingCourses/ExistingCourses.css": 9035,
	"components/GradingCategory/GradingCategory.css": 8695,
	"components/Header/Header.css": 2627,
	"components/Heading/Heading.css": 4843,
	"components/Input/Input.css": 9275,
	"components/InstitutionType/InstitutionType.css": 8943,
	"components/Label/Label.css": 6055,
	"components/LoadingButton/LoadingButton.css": 8875,
	"components/MainControlButton/MainControlButton.css": 7891,
	"components/MessageCentre/MessageCentre.css": 4311,
	"components/MetricCatalogueModal/MetricCatalogueModal.css": 3425,
	"components/Mfa/Mfa.css": 3187,
	"components/MultiplePlayers/Multiplayers.css": 8938,
	"components/MyCourses/MyCourses.css": 1159,
	"components/NavSidebar/NavSidebar.css": 8227,
	"components/Navbar/Navbar.css": 941,
	"components/NewCategory/NewCategory.css": 787,
	"components/Password/Password.css": 1635,
	"components/Player/Player.css": 9043,
	"components/PlayerCVSectionSettings/PlayerCVSectionSettings.css": 2755,
	"components/PlayerCentre/PlayerCentre.css": 3993,
	"components/PlayerInfo/PlayerInfo.css": 7523,
	"components/PlayersCard/PlayersCard.css": 6351,
	"components/Profile/Profile.css": 2279,
	"components/ProfileFieldType/ProfileFieldType.css": 4479,
	"components/QualificationGrading/QualificationGrading.css": 767,
	"components/RegisterPlayer/RegisterPlayer.css": 7573,
	"components/Search/Search.css": 3321,
	"components/SessionTimeoutWarning/SessionTimeoutWarning.css": 4975,
	"components/Sidebar/Sidebar.css": 3783,
	"components/Textarea/Textarea.css": 4853,
	"components/TransferableSkills/TransferableSkills.css": 6211,
	"components/UnitInfo/UnitInfo.css": 4705,
	"components/UserProfileCard/CreateProfileField.css": 5812,
	"components/WorkExperience/WorkExperience.css": 723,
	"index.css": 9555,
	"pages/AllCourses/AllCourses.css": 7199,
	"pages/CVSectionSettings/CVSectionSettingsPage.css": 2314,
	"pages/ContentReview/ContentReview.css": 7883,
	"pages/Dashboard/AdminDashboard.css": 8320,
	"pages/IndividualAccounts/IndividualAccounts.css": 6079,
	"pages/MetricCatalogue/MetricCatalogue.css": 4011,
	"pages/OrganizationUserProfile/OrganizationUserProfile.css": 5903,
	"pages/PlayerCategories/PlayerCategories.css": 1655,
	"pages/SkillCatalogue/SkillCatalogue.css": 4889,
	"pages/Support/Support.css": 8119,
	"pages/Template4Stats/Template4Stats.css": 8423,
	"pages/Theme/theme.css": 3623,
	"pages/UserProfile/UserProfile.css": 1403,
	"pages/WorkExperienceSummary/WorkExperienceSummary.css": 1127,
	"styles/legacy-buttons.css": 9219,
	"styles/shell.css": 3074,
	"styles/tokens.css": 5392,
	"styles/ui.css": 5336
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9074;